import React, { PureComponent } from "react";
import { v4 as uuidv4 } from "uuid";
import classNames from "../../utils/classnames";

export class Footer extends PureComponent {
  render() {
    const { copyright, links, className, fixed, ...others } = this.props;
    const cls = classNames({
      "weui-footer": true,
      "weui-footer_fixed-bottom": fixed
    }, className);

    return (
      <div className={ cls } { ...others }>
        { links && <p className="weui-footer__links">{
          links.map(l => <a href={ l.href } key={ uuidv4() } className="weui-footer__link">{ l.title }</a>)
        }</p> }
        { copyright && <p className="weui-footer__text">{ copyright }</p> }
      </div>
    );
  }
}
